import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Tab } from '../app-enums/tab';
import { HttpErrorExtended } from '../app-models/http-error-extended.model';
import { UiSpinnerService } from '../app-services/ui-spinner.service';
import { EnvironmentHelper } from '../services/environment-helper';
import { SEARCH_ADDRESS_URL } from '../app-env/app-env.constants';
import {AppMessageService} from "../app-services/app-message.service";

@Injectable()

export class HttpErrorsInterceptor implements HttpInterceptor {

  constructor(private environmentHelper: EnvironmentHelper,
              private router: Router,
              private appMessageService: AppMessageService,
              private uiSpinnerService: UiSpinnerService) {
  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(tap(() => {
      },
      (err: any) => {
        this.uiSpinnerService.stop();
        if (!(err instanceof HttpErrorResponse)) {
          return;
        }
        if ((err.status === 401 || err.status === 0) && !err.url.includes(this.environmentHelper.urlDvr)
          && !err.url.includes(SEARCH_ADDRESS_URL)
          && !err.url.includes('api-maps.yandex.ru')) {
          this.appMessageService.openSnackBar("Ошибка авторизации")
          setTimeout(() => this.router.navigate([Tab.LOGOUT]).then(), 3000);
        }
        if (err.status === 403) {
          this.appMessageService.openSnackBar(err.error.message, true);
        }
        console.error(err);
        throw new HttpErrorExtended(err, req?.method);
      }));
  }
}
